import api from "@/app/api";
import Guid from "@/app/types/common/guid";
import { Instant, LocalDate, LocalTime } from "@js-joda/core";
import {ModelObject, BaseModelObject, ValidationRule} from "@/app/services/modelObject";
import ServiceBase from "@/app/services/serviceBase";
import converters from "@/app/services/converters"
import { EnumCacheEntityType } from "./enums/enumCacheEntityType.generated";

// Model Objects

export class TypesModifiedSinceResults extends ModelObject<TypesModifiedSinceResults> {

    /**
    * The last sequence number issued in the system. Usually stored by the receiver and then used in the next call to GetTypesModifiedSince to get types modified after the first call.
    */
    public latestSequenceNumber: number = 0;
    /**
    * All types which may have been modified since AfterSequence. This is deliberately generous in that it may include types where an update was attempted but actually resulted in no modification (Eg setting is_default on a Vat Code which was already the default), or types which have been modified and then modified back to the initial value.
    */
    public modifiedEntityTypes: EnumCacheEntityType[] = [];

    public constructor(jsonSerializedObject?: any) {
        super();
        if (jsonSerializedObject) {
          this.latestSequenceNumber = jsonSerializedObject.latestSequenceNumber;
          this.modifiedEntityTypes = jsonSerializedObject.modifiedEntityTypes.map((v: any) => EnumCacheEntityType.getByValue(v));
        }

    }

    public toJsonSerializedObject(): any {
        const toRet = {} as any;
        toRet.latestSequenceNumber = this.latestSequenceNumber;
        toRet.modifiedEntityTypes = this.modifiedEntityTypes.map(v => v.value);
        return toRet;
    }

    public toProto(): any {
      return this.toJsonSerializedObject();
    }

    public toBinary(): Uint8Array {
      return new TextEncoder().encode(JSON.stringify(this.toJsonSerializedObject()));
    }

    public validationRules: ValidationRule = [
            {field: "latestSequenceNumber", rule: (v: any) => v == null || v >= -9223372036854775808 || "LatestSequenceNumber is not greater than minimum allowed value: -9223372036854775808"},
            {field: "latestSequenceNumber", rule: (v: any) => v == null || v <= 9223372036854775807 || "LatestSequenceNumber is above maximum allowed value: 9223372036854775807"},
    ];
}


export class ModifiedTypeService extends ServiceBase {

  public async getTypesModifiedSince(tenantId: Guid, afterSequence: number, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<TypesModifiedSinceResults> {
    const req = {
    tenantId:tenantId.toString(),
    afterSequence:afterSequence,
    };
    const extractor = (response:any) => new TypesModifiedSinceResults(response.results);;
    return this.makeJsonRequest("modifiedType/v1/getTypesModifiedSince", req, false, extractor, opts);
  };
}

export const modifiedTypeService = new ModifiedTypeService();